import config from 'config'
import Favico from 'favico.js'
import themeVars from 'ui_theme/site/globals/site.variables'

let favicon = null
let faviconTimer = null

export function initFavico() {
  if (config.isTest) return
  const iconElement = document.querySelector('link[rel*="icon"][sizes="32x32"]')
  favicon = new Favico({
    animation: 'none',
    element: iconElement,
    bgColor: themeVars.newBerry,
  })
  // Kevin Rademan 2020-05-29
  // We include different favicons for different browsers and styles. The problem is that there
  // is no way to know which <link> element is actualy used to display the icon. The work around
  // I've found is to simply remove all <link> icon except the highest resolution value. This should
  // be ok as most tools use the static html to grab the icons they need from the head
  const iconLinks = [
    ...document.querySelectorAll('link[rel*="icon"]:not([sizes="32x32"])'),
  ]
  iconLinks.forEach(element => element.remove())
}

export function getFavico() {
  return favicon
}

export function updateCount(count) {
  if (!favicon || config.isTest) return
  if (faviconTimer) {
    clearTimeout(faviconTimer)
  }
  faviconTimer = setTimeout(() => {
    favicon.badge(normalizeCount(count))
  }, 100)
}

export function normalizeCount(count) {
  if (!count) return 0
  if (count < 0) return 0
  if (count > 99) return '99+'
  return count
}
